// @flow
import get from 'lodash/get';
export const getLeagueDraftOrder = (
	state: Object) => get(state, 'leagues.show_order.ordered_ids', []
);

export default getLeagueDraftOrder;